"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Slider = _interopRequireDefault(require("@eig-builder/core-ui/Slider"));

var _Grid = _interopRequireDefault(require("@eig-builder/core-ui/Grid"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _mobileDetectionHelper = _interopRequireDefault(require("@eig-builder/core-utils/helpers/mobile-detection-helper"));

var _templateObject, _templateObject2, _templateObject3;

var ImageDetailsZoomBox = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  width: 400px;\n  border-radius: 5px;\n  padding: 3px 10px 0px;\n  top: 30px;\n  z-index: 10;\n  left: 50%;\n  margin-left: -200px;\n  p {\n    line-height: 25px;\n  }\n  ", "\n"])), function (props) {
  return props.mobile && (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    width: 100%;\n    margin-left: auto;\n    left: auto;\n  "])));
});

var StyledSlider = (0, _styledComponents["default"])(_Slider["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 5px;\n"])));

var ImageZoomSlider = function ImageZoomSlider(_ref) {
  var setZoom = _ref.setZoom,
      value = _ref.value;

  var zoomOut = function zoomOut() {
    if (value !== 1) {
      setZoom(value - 0.1);
    }
  };

  var zoomIn = function zoomIn() {
    if (value < 2) {
      setZoom(value + 0.1);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ImageDetailsZoomBox, {
    mobile: (0, _mobileDetectionHelper["default"])()
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    dataElementLabel: "image-selector--details--zoom-out",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--details--zoom-out",
    onClick: zoomOut,
    disabled: value === 1
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "zoom_out"
  }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(StyledSlider, {
    min: 1,
    max: 2,
    step: 0.1,
    value: value,
    onChange: function onChange(e, value) {
      return setZoom(value);
    },
    dataElementLabel: "image-selector--details--zoom-slider",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--details--zoom-slider"
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    dataElementLabel: "image-selector--details--zoom-in",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementId: "image-selector--details--zoom-in",
    onClick: zoomIn,
    disabled: value >= 2
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "zoom_in"
  }))))));
};

ImageZoomSlider.propTypes = {
  setZoom: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].number
};
var _default = ImageZoomSlider;
exports["default"] = _default;